module.exports = __webpack_public_path__ + "media/images/ui__arrowLeftInactive--dark-0f980758ac54fc095075c986920402cb.png";